export default __webpack_public_path__ + "static/mazda_full-6ea46302baa81662420d91ff86553d81.png";